import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { AvisosDialogService, ToastService } from 'govbr-lib';
import { finalize } from 'rxjs/operators';
import { ClienteSiga } from 'src/app/models/ClienteSiga';
import { SigaService } from 'src/app/services/siga.service';
import { Login } from '../../../models/Login';
import { AutenticacaoService } from './../service/autenticacao.service';
import { EsqueciMinhaSenhaModalComponent } from '../esqueci-minha-senha-modal/esqueci-minha-senha-modal.component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'gov-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  formLogin: FormGroup;
  selecionarCliente = false;
  clientesSiga: ClienteSiga[];
  spinnerUsuario = false;
  spinnerEntrar = false;
  loginDto: Login;
  cdContato: number;

  constructor(
    private service: AutenticacaoService,
    private toaster: ToastService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private sigaService: SigaService,
    private router: Router,
    private avisosDialogService: AvisosDialogService,
    private coockieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.formLogin = this.formBuilder.group({
      login: [null, [Validators.required, Validators.minLength(5)]],
      cdCliente: [null, Validators.required],
      senha: [null, Validators.required],
    });

  }

  login() {
    this.spinnerEntrar = true;
    const login = this.formLogin.get('login').value.toLocaleLowerCase();
    const cdCliente = this.formLogin.get('cdCliente').value;
    const senha = this.formLogin.get('senha').value;

    this.loginDto = {
      login: login,
      cdCliente: cdCliente,
      senha: senha,
    }

    const clienteAutenticado = this.clientesSiga.find(cliente => cliente.cdCliente === cdCliente);
    const cdContato = clienteAutenticado.cdContato;

    this.coockieService.set('dadosUsuario', JSON.stringify({
      cdCliente: cdCliente,
      cdContato: cdContato,
    }), 1, '/');

    this.service.autenticacao(this.loginDto)
      .pipe(
        finalize(() => {
          this.spinnerEntrar = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.router.navigate(['/']);
        },
        (error) => {
          if (error.status === 500) {
            this.toaster.show({
              type: 'danger',
              text: 'O servidor pode estar indisponível, consulte um administrador do sistema.',
            });
          } else if (error.status === 401) {
            this.abrirModalPrimeiroAcesso(login, cdCliente, senha);
          } else {
            this.toaster.show({
              type: 'warning',
              text: (error && error.error && error.error.detail) || 'Usuário ou senha incorretos.'
            });
          }
        }
      );
  }


  abrirModalPrimeiroAcesso(login: any, cdCliente: any, senha: any) {
    const clienteAutenticado = this.clientesSiga.find(cliente => cliente.cdCliente === cdCliente);
    const cdContato = clienteAutenticado.cdContato;

    this.avisosDialogService.exibirDialogAviso({
      titulo: 'Primeiro Acesso',
      conteudo: ['Usuário não encontrado no sistema. É seu primeiro acesso?'],
      rotuloConfirmar: 'Sim',
      rotuloCancelar: 'Não',
    });

    this.avisosDialogService.resultadoDialog$.subscribe(response => {
      if (response === 'confirmar') {

        localStorage.setItem('infoUserLogin', JSON.stringify({
          login: login,
          cdCliente: cdCliente,
          senha: senha,
          cdContato: cdContato,
        }))

        this.router.navigate(['/usuarios/cadastrar']);

      } else {
        this.toaster.show({
          type: 'info',
          text: 'Por favor, entre em contato com a equipe de suporte do Siga para resolver seu problema de Acesso.'
        });

      }
    });
  }

  getDadosUsuario() {
    const login = this.formLogin.get('login').value as string;

    if (login != null && login.length > 4) {
      this.spinnerUsuario = true;
      this.clientesSiga = [];

      this.sigaService.getDadosLogin(login.toLocaleLowerCase())
        .pipe(
          finalize(() => {
            this.spinnerUsuario = false;
          })
        )
        .subscribe((clientes: ClienteSiga[]) => {
          this.clientesSiga = clientes;
          if (clientes.length > 1) {
            this.selecionarCliente = true;
          } else {
            this.selecionarCliente = false;
            this.formLogin.get('cdCliente').setValue(clientes[0].cdCliente);
          }

        }, (error) => {
          this.formLogin.get('login').setErrors({ notValid: true })
          this.toaster.show({
            type: 'warning',
            text: error.error.detail != undefined ? error.error.detail : 'Erro ao tentar se conectar ao SIGA.'
          })
        })
    }
  }

  openDialog() {
    this.dialog.open(EsqueciMinhaSenhaModalComponent, {
      width: '30rem',
      disableClose: true,
      panelClass: 'tirar-padding-dialog',
    });
  }

}
